import { AxiosInstance } from 'axios';
import { FetchingRequestParamsModels } from 'models/Shared/FetchingRequestParamsModels';
import { TimezoneModel } from './TimezoneService';

export interface CountryModel {
  id: string;
  code: string;
  name: string;
}

export const getAll =
  (axios: AxiosInstance) =>
  async (params?: FetchingRequestParamsModels | undefined): Promise<CountryModel[]> => {
    return await axios
      .get('settings/country', {
        params,
      })
      .then(({ data }) => data.items);
  };

export const getTimezonesService =
  (axios: AxiosInstance) =>
  async (params?: FetchingRequestParamsModels | undefined): Promise<TimezoneModel[]> => {
    return await axios.get('settings/timezone', { params }).then(({ data }) => data.items);
  };
